export default __webpack_public_path__ + "be0c4d3e665547cd52efb0c59140e9a0.png";